import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  BoxProps,
  IconButton,
  Typography,
  TypographyProps,
} from '@mui/material';
// ICONS
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// COMPONENTS
import { headerHeight } from '../../../../components/Mobile/Header';
import { whiteButtonStyles } from '../../../../components/Button/styles';
// HELPERS
import { isMobileScreen, SafeAreaGaps } from '../../../../helper';
// CONSTANTS
import { SubjectColors, TP_COLORS } from '../../../../constants';

interface QuizHistoryJumbotronProps {
  isBackButtonVisible?: boolean;
}

// STYLES
const titleTextProps: TypographyProps = {
  variant: 'h1',
  style: {
    color: TP_COLORS.white,
    fontWeight: 500,
  },
  sx: {
    fontSize: {
      xs: '26px',
      md: '28px',
      lg: '30px',
      xl: '32px',
    },
  },
};

const QuizHistoryJumbotron: React.FC<QuizHistoryJumbotronProps> = ({
  isBackButtonVisible,
}) => {
  // HOOKS
  const navigate = useNavigate();

  // BOOLEANS
  const isMobile = isMobileScreen();

  // STYLES
  const defaultContainerStyles: BoxProps['sx'] = {
    background: `url('${process.env.PUBLIC_URL}/images/backgrounds/bg-user-quiz-history.png') bottom right/contain no-repeat, ${SubjectColors[5]}`,
    pt: {
      xs: `calc(${SafeAreaGaps.top} + ${headerHeight} + 15px)`,
      sm: `calc(${SafeAreaGaps.top} + 15px)`,
    },
    pb: '15px',
    pr: '15px',
    pl: {
      xs: '15px',
      sm: '20px',
      md: '30px',
      lg: '35px',
    },
  };

  // RENDER
  return (
    <Box component="div" sx={defaultContainerStyles}>
      <div
        style={{
          paddingTop: isMobile
            ? `calc(15px + ${headerHeight} + ${SafeAreaGaps.top})`
            : '40px',
        }}
      >
        {!isMobile && isBackButtonVisible ? (
          <Box sx={{ display: { xs: 'none', sm: 'block' }, minHeight: '34px' }}>
            <IconButton
              size="small"
              sx={whiteButtonStyles}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon sx={{ color: TP_COLORS.black }} />
            </IconButton>
          </Box>
        ) : (
          <Box style={{ minHeight: '34px' }} />
        )}

        <div style={{ marginTop: '80px' }}>
          <Typography {...titleTextProps}>Quiz History</Typography>
        </div>
      </div>
    </Box>
  );
};

export default QuizHistoryJumbotron;
